import { ReactElement } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import ClinicWebsiteSubSection, { IClinicWebsiteSubSectionProps } from "./InfoInPortalSection/ClinicWebsiteSubSection";
import OfferedSpecialtiesSubSection, { IOfferedSpecialtiesSubSectionProps } from "./InfoInPortalSection/OfferedSpecialtiesSubSection";
import OpeningHoursSubSection, { IOpeningHoursSubSectionProps } from "./InfoInPortalSection/OpeningHoursSubSection";
import SiteDescriptionSubSection, { ISiteDescriptionSubSectionProps } from "./InfoInPortalSection/SiteDescriptionSubSection";
import SiteOnlineNameSubSection, { ISiteOnlineNameSubSectionProps } from "./InfoInPortalSection/SiteOnlineNameSubSection";

interface IInfoInPortalSectionProps extends
    IOfferedSpecialtiesSubSectionProps,
    IOpeningHoursSubSectionProps,
    IClinicWebsiteSubSectionProps,
    ISiteDescriptionSubSectionProps,
    ISiteOnlineNameSubSectionProps { }

const InfoInPortalSection: React.FC<IInfoInPortalSectionProps> = (props): ReactElement => {
    const {
        localizedDisplayName,
        openingHours,
        localizedOpeningHoursNote,
        localizedDescription,
        specialties,
        offeredSpecialtyIds,
        localizedWebsite
    } = props;

    const { getText } = useTranslation();

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">{getText("ClinicInfo_InfoInPortalLabel")}</h3>
            </div>

            <div className="view-section-body">
                <label className="form-label">{getText("ClinicInfo_InfoInPortalDescription")}</label>

                <SiteOnlineNameSubSection localizedDisplayName={localizedDisplayName} />
                <SiteDescriptionSubSection localizedDescription={localizedDescription} />
                <OpeningHoursSubSection
                    openingHours={openingHours}
                    localizedOpeningHoursNote={localizedOpeningHoursNote}
                />
                <OfferedSpecialtiesSubSection
                    specialties={specialties}
                    offeredSpecialtyIds={offeredSpecialtyIds}
                />
                <ClinicWebsiteSubSection localizedWebsite={localizedWebsite} />

            </div>
        </div>
    );
};

export default InfoInPortalSection;
